import { render, staticRenderFns } from "./ManageAvatarPage.vue?vue&type=template&id=634d6b11&"
import script from "./ManageAvatarPage.vue?vue&type=script&lang=js&"
export * from "./ManageAvatarPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports